import styled from 'styled-components';

const DropOffFoundText = styled.span`
  margin-top: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
`;

export { DropOffFoundText };
